// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.test.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  amplifyEnv: 'dev',
  serviceEnv: 'test',
  domain: 'https://dcr-portal-test.dna.nfl.net',
  region: 'us-east-1',
  auth: {
    hostname: 'dcr-portal-test-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://dcr-portal-test.dna.nfl.net/login'],
    response_type: 'code',
    client_id: '282l5j84vrpl55quh59cqipiuv',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_1XcWNngKA',
    identity_pool_id: 'us-east-1:c84ad9d9-c53a-43e0-b08c-71651e32ff13',
    domain: 'dcr-portal-test.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://dcr-portal-test.dna.nfl.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
  dcr_hub_link: 'https://dcr-hub-dev.dna.nfl.net/',
};
